import { MoUoType } from 'sigo-package'

export function CalcularMOUtilizado(LineaCodigoCub: string, MoUo: MoUoType[]): number {
  const lineaCodigoCub = MoUo.find(e => e.LineaCodigoCub === LineaCodigoCub)
  return !lineaCodigoCub ? 0 : lineaCodigoCub.Cantidad
}